import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the InventarioServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InventarioServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Get item list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getList(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Item/readItem', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Create new item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    create(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Item/createItem', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Update item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    update(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Item/updateItem', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Delete item
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    delete(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Item/deleteItem', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/inventario-service/inventario-service.ts